module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 header"
  }, [_c('router-link', {
    staticClass: "material-icons back-link",
    attrs: {
      "to": '/lists/' + _vm.$route.params.id
    }
  }, [_vm._v("chevron_left")]), _vm._v(" "), _c('h1', [_vm._v("Add items")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 list"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.filteredItems), function(globalItem) {
    return _c('li', {
      staticClass: "list-item global-item",
      on: {
        "click": function($event) {
          _vm.addListItem(globalItem)
        }
      }
    }, [_vm._v(_vm._s(globalItem.name))])
  })), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": "/global-list"
    }
  }, [_vm._v("Don't see your item? Add a new one.")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8369d30c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewListItem.vue
// module id = 140
// module chunks = 0